'use client'
import { alertAnatomy as parts } from '@chakra-ui/anatomy'
import {
  Alert as ChakraAlert,
  createMultiStyleConfigHelpers,
} from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { AlertProps } from './Alert.types'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const comumToastStyle = (bgColor: string) => ({
  container: {
    boxShadow: '0.0625rem 0.0625rem 0.5rem rgba(0, 0, 0, 0.3)',
    gap: '1rem',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    alignItems: 'center',
    backgroundColor: bgColor,
    width: '90vw',
    maxWidth: '30rem',
  },
  title: {
    color: 'white',
    fontSize: '1rem',
    fontWeight: '600',
    width: '100%',
  },
  description: {
    color: 'white',
    fontSize: '0.875rem',
    fontWeight: 'normal',
    width: '100%',
  },
  icon: {
    size: '1.5rem',
    color: 'white',
    boxSize: '1.5rem',
    margin: 0,
  },
})

const errorStyleVariant = definePartsStyle({
  ...comumToastStyle('red.500'),
})

const successStyleVariant = definePartsStyle({
  ...comumToastStyle('green.500'),
})

const warningStyleVariant = definePartsStyle({
  ...comumToastStyle('yellow.500'),
})

const positiveStyleVariant = definePartsStyle({
  ...comumToastStyle('blue.500'),
})

const infoStyleVariant = definePartsStyle({
  ...comumToastStyle('gray.800'),
})

export const AlertStyle = defineMultiStyleConfig({
  variants: {
    error: errorStyleVariant,
    success: successStyleVariant,
    warning: warningStyleVariant,
    positive: positiveStyleVariant,
    info: infoStyleVariant,
  },
})

export default forwardRef(function Alert(
  props: AlertProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraAlert {...props} ref={ref} translate="no" />
})
